import { Accordion } from '@components/accordion';
import { Modal } from '@components/modal';
import { useFetchTag } from 'api/customProperty/customPropertyService';
import { type Disclosure } from 'interfaces/disclosure/Disclosure.interface';
import { DetailsRow } from 'pages/Assets/Meters/modal/MeterDetailsModal/styled';
import { type FC, type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { AccordionSection } from '@components/accordionSection';
interface TagDetailsModalProps extends Disclosure {
  tagId?: number;
  handleEditOpen: () => void;
}

const TagDetailsModal: FC<TagDetailsModalProps> = ({
  tagId,
  isOpen,
  handleOpen,
  handleClose,
  handleEditOpen,
}) => {
  const { t } = useTranslation();
  const [foundAsset, setFoundAsset] = useState(false);
  const { data: tagData, isFetching } = useFetchTag(tagId);

  const createAssetAccordion = (asset: {
    id: number;
    name: string;
  }): ReactNode => {
    if (!foundAsset && asset) setFoundAsset(true);
    return <Accordion key={asset.id} title={asset.name} enableTooltip={true} />;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      onOpen={handleOpen}
      title={tagData?.property_definition.display_name}
      useSkeleton={true}
      maxWidth={600}
      actionBtns={{
        secondary: {
          label: 'Edit',
          onClick: () => {
            handleClose();
            handleEditOpen();
          },
        },
      }}
    >
      <div className="flex flex-col gap-6">
        <div className="border border-gray-10 rounded-lg">
          <div className="px-4 py-2 border-b border-gray-10">
            {isFetching ? (
              <Skeleton width={100} />
            ) : (
              <h3 className="uppercase text-gray-60 font-bold">
                {t('common.details')}
              </h3>
            )}
          </div>
          <DetailsRow>
            {isFetching ? (
              <Skeleton width={120} />
            ) : (
              <p className="text-gray-60">{t('common.name')}</p>
            )}
            <div>
              {isFetching ? (
                <Skeleton width={120} height={24} borderRadius={20} />
              ) : (
                <p>{tagData?.property_definition.name}</p>
              )}
            </div>
          </DetailsRow>
          <DetailsRow>
            {isFetching ? (
              <Skeleton width={120} />
            ) : (
              <p className="text-gray-60">{t('common.description')}</p>
            )}
            <div>
              {isFetching ? (
                <Skeleton width={120} height={24} borderRadius={20} />
              ) : (
                <div>{tagData?.property_definition.description}</div>
              )}
            </div>
          </DetailsRow>
        </div>
        <AccordionSection title={t('common.assets')} isLoading={isFetching}>
          {tagData?.assets?.map((asset) => {
            return createAssetAccordion(asset);
          })}
          {!foundAsset && (
            <Accordion
              title={t('common.empty.accordion', {
                value: t('common.assets').toLowerCase(),
              })}
            />
          )}
        </AccordionSection>
      </div>
    </Modal>
  );
};

export default TagDetailsModal;
